import React, { useContext } from "react";
import { TextField } from "@mui/material";
import GroupBDRBiologists from "../FieldTags/GroupBDRBiologists";
import { UserContext } from "../../context/UserContext";
import xplanLabels from "../../util/XplanLabels";
import ROLES from "../../util/roles";
import HistoryLogElement from "./HistoryLogElement";
import { checkRole } from "../../util/FormUtils";

const newPlan = window.location.pathname === "/xplans/new";

const AssayDetails = ({ assayDetails, handleChange, xplans, required }) => {
    const { user } = useContext(UserContext);
    const canEdit = checkRole(user, [ROLES.BIOLOGIST, ROLES.APPROVER]);

    return (
        <div id="assayDetails" className="planField">
            <GroupBDRBiologists />
            <TextField
                name="assayDetails"
                label={xplanLabels.assayDetails}
                InputLabelProps={{ shrink: true }}
                type="text"
                required={required.includes("assayDetails")}
                value={assayDetails ? assayDetails : ""}
                onChange={(e) => handleChange("assayDetails", e.target.value)}
                multiline
                minRows={1}
                className="fullLength"
                disabled={!canEdit}
            />
            {!newPlan && <HistoryLogElement xplans={xplans} label={"assayDetails"} />}
        </div>
    );
};

export default AssayDetails;
